import React, { useEffect, useState, useContext } from 'react';
import { isMobileDevice } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { RESIZE } from 'common/constants/SharedConstants';
import ContactKFCView from '../../Presentation/AU/ContactKFCView';
const ContactKFCContainer = props => {
  const { contentData = {}, history, tenantId } = props;
  let headerFormData = {};
  let bodyFormData = {};
  if (contentData !== null) {
    headerFormData = contentData.headerFormData;
    bodyFormData = contentData.bodyFormData;
  }
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { userOrderState } = useContext(UserOrderContext);
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);
  return (
    <ContactKFCView
      userOrderState={userOrderState}
      headerFormData={headerFormData}
      bodyFormData={bodyFormData}
      isMobile={isMobile}
      history={history}
      tenantId={tenantId}
    />
  );
};
export default ContactKFCContainer;
